import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MsalAzureLoginService } from '../services/msal-azure-login.service';

export const noAuthGuard: CanActivateFn = () => {
  const router = inject(Router);

  // When we return from a B2C sign-up / sign-in, the auth response is still sitting
  // in the URL (hash `#code=…&state=…` or query). MSAL hasn't consumed it yet — that
  // happens inside AuthComponent's handleRedirect(), which is ALSO what decides where
  // the user goes next (a not-yet-onboarded customer must land on /register, not the
  // dashboard). If we bounce to the dashboard here, AuthComponent never loads and that
  // routing decision never runs — so every returning user is dumped on the dashboard
  // and only reaches /register after a logout+login (which clears the account keys and
  // changes the timing). Let the route load so the redirect can be processed.
  const url = (window.location.hash || '') + (window.location.search || '');
  const isRedirectReturn = /[?#&](code|id_token|state|error)=/.test(url);
  if (isRedirectReturn) return true;

  // Normal case: an already-authenticated user opening the app at '/' shouldn't see
  // the sign-up chooser — send them to their dashboard.
  const hasAccount = localStorage.getItem('msal.1.account.keys');
  if (hasAccount) {
    router.navigate([MsalAzureLoginService.dashboardPath()]);
    return false;
  }
  return true;
};
